import { createContext, useContext } from 'react';
export const TableContext = createContext({});
export function useTableContext() {
    const context = useContext(TableContext);
    if (!context) {
        throw new Error('useTableProvider must be used within a <SearchResultsTable />');
    }
    return context;
}
